import type { Section } from "../sections";

type Props = {
  sections: Section[];
  active: number;
  onSelect: (index: number) => void;
};

export function PageIndex({ sections, active, onSelect }: Props) {
  return (
    <nav className="home-index" aria-label="Section navigation">
      {sections.map((section, index) => (
        <button
          key={section.id}
          type="button"
          className="home-index__item"
          data-active={index === active}
          onClick={() => onSelect(index)}
          aria-current={index === active ? "true" : undefined}
        >
          <span className="home-index__num">
            {String(index + 1).padStart(2, "0")}
          </span>
          <span className="home-index__label">{section.name}</span>
        </button>
      ))}
    </nav>
  );
}
